import React from 'react';
import { View } from 'react-native';

import { Text } from '../../components';
import { Card } from '../../design/components';
import { useThemedStyles } from '../../hooks/useThemedStyles';
import { createCorrectMarketRestockStyles } from './CorrectMarketRestockView.styles';
import RestockCorrectionStat from './RestockCorrectionStat';
import RestockCorrectionVariance from './RestockCorrectionVariance';

// Review step for an already confirmed stock count: the Missing and Extra this correction will record.
const RestockCorrectionPreview = ({ confirmedPreview, reason }) => {
	const styles = useThemedStyles(createCorrectMarketRestockStyles);

	return (
		<>
			<Text style={styles.sectionTitle}>Review resulting Missing and Extra</Text>
			<Card>
				<Text style={styles.notice}>
					Only the delivered quantities listed below will be corrected. The confirmed count and
					current live count will remain unchanged. Sentry compares the expected stock after this
					correction with the confirmed count and will record the results shown here.
				</Text>
			</Card>
			{confirmedPreview.items.map(previewItem => (
				<View
					key={previewItem.item.id}
					testID={`restock-correction-preview-item-${previewItem.item.id}`}
				>
					<Card tone="raised" style={styles.productCard}>
						<View>
							<Text style={styles.productName}>{previewItem.item.product.name}</Text>
							{previewItem.item.selection && (
								<Text style={styles.hint}>Selection {previewItem.item.selection}</Text>
							)}
						</View>
						<View style={styles.statRow}>
							<RestockCorrectionStat label="Corrected delivered" value={previewItem.correctedDeliveredQuantity} />
							<RestockCorrectionStat label="Expected stock" value={previewItem.correctedExpectedQuantity} />
							<RestockCorrectionStat label="Confirmed count" value={previewItem.confirmedQuantity} hint="Unchanged" />
						</View>
						<View style={styles.statRow}>
							<RestockCorrectionVariance label="Resulting Missing" variance={previewItem.missing} />
							<RestockCorrectionVariance label="Resulting Extra" variance={previewItem.extra} />
						</View>
					</Card>
				</View>
			))}
			<Card style={styles.productCard}>
				<Text style={styles.productName}>Affected products total</Text>
				<View style={styles.statRow}>
					<RestockCorrectionVariance label="Resulting Missing" variance={confirmedPreview.totals.missing} />
					<RestockCorrectionVariance label="Resulting Extra" variance={confirmedPreview.totals.extra} />
				</View>
			</Card>
			<Card style={styles.productCard}>
				<Text style={styles.fieldLabel}>Reason for delivered-quantity correction</Text>
				<Text style={styles.previewReasonText}>{reason.trim()}</Text>
			</Card>
		</>
	);
};

export default RestockCorrectionPreview;
